// extracted by mini-css-extract-plugin
export var scrollArea = "_pu-0";